import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'es', 'de', 'it', 'fr', 'ru'];

  constructor(private translateService: TranslateService, private cookieService: CookieService) {
    let browserLang;
    this.translateService.addLangs(this.languages);

    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    } else {
      browserLang = this.translateService.getBrowserLang();
    }

    this.translateService.use(browserLang.match(/en|es|de|it|fr|ru/) ? browserLang : 'en');
  }

  public setLanguage(lang) {
    this.translateService.use(lang);
    this.cookieService.set('lang', lang);
  }

  public getLanguage() {
    return this.translateService.getBrowserLang();
  }
}
